<div class="d-flex flex-column justify-content-center czi-progress-container" data-uit="czi-conversion-info">
    <!-- Conversion in Progress -->
    <ng-container *ngIf="isConversionInProgress">
        <div class="d-flex align-items-center" data-uit="czi-conversion-info-status">
            <ca-icon name="loading" size="s" data-uit="file-upload-loader"></ca-icon>
            <span class="ms-2 font-sm">
                {{ conversionInProgressMessage }}
            </span>
        </div>
    </ng-container>

    <!-- Conversion Failed -->
    <ng-container *ngIf="numberOfConversionFailedFiles > 0">
        <div
            [ngClass]="{
                'czi-conversion-info-dataset-explorer': isInvalidFilesNotificationVisible,
                'ms-0': !isInvalidFilesNotificationVisible,
            }"
            class="d-flex align-items-center"
        >
            <div class="d-flex">
                <span class="font-sm text-danger conversion-warning" [ngbTooltip]="failedConversionTooltip" placement="bottom">
                    {{ failedConversionMessage }}
                </span>
            </div>

            <!-- Retry Button -->
            <button
                *ngIf="!isConversionInProgress"
                class="btn ca-btn-icon czi-retry-btn"
                data-uit="czi-conversion-retry-btn"
                [attr.aria-label]="'CZI_CONVERSION.RETRY_CONVERSION' | translate"
                (click)="retry()"
                [ngbTooltip]="'CZI_CONVERSION.RETRY_CONVERSION' | translate"
                trigger="hover"
            >
                <ca-icon name="circle-arrow" [removeSVGAttributes]="['stroke']" size="s"></ca-icon>
            </button>
        </div>
    </ng-container>
</div>
